function UnknownCommand() {
  return 'Unknown command. Type \'help\' to list all commands.';
}

export default UnknownCommand;



// WEBPACK FOOTER //
// ./src/commands/UnknownCommand.js